import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.468 7.514a4.52 4.52 0 0 0 1.103-2.943A4.576 4.576 0 0 0 8 0H1.143a1.143 1.143 0 1 0 0 2.286h.571v11.428h-.571a1.143 1.143 0 1 0 0 2.286h8c2.52 0 4.571-2.05 4.571-4.571 0-1.668-.907-3.115-2.246-3.915M4 2.286h4a2.29 2.29 0 0 1 2.286 2.286A2.29 2.29 0 0 1 8 6.857H4zm5.143 11.428H4V9.143h5.143c1.26 0 2.285 1.025 2.285 2.253s-1.025 2.318-2.285 2.318" }, null, -1)
  ])))
}
export default { render: render }